import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const AIRouter = lazy(() => import('@cobliteam/ai'));
const AIAutomations = lazy(() => import('@cobliteam/ai/src/pages/AIAutomations'));
const AIAutomationRuns = lazy(() => import('@cobliteam/ai/src/pages/AIAutomationRuns'));
const AIFiles = lazy(() => import('@cobliteam/ai/src/pages/AIFiles'));

const routes = [
  {
    title: locationName[Location.AI],
    path: Location.AI,
    component: AIRouter,
    featureFlag: 'aiChat',
    exact: false,
    routes: [
      {
        title: locationName[Location.AI_AUTOMATION],
        path: Location.AI_AUTOMATION,
        component: AIAutomations,
        featureFlag: 'aiChat',
        exact: true,
      },
      {
        title: locationName[Location.AI_AUTOMATION_RUNS],
        path: Location.AI_AUTOMATION_RUNS,
        component: AIAutomationRuns,
        featureFlag: 'aiChat',
        exact: true,
      },
      {
        title: locationName[Location.AI_FILES],
        path: Location.AI_FILES,
        component: AIFiles,
        featureFlag: 'aiChat',
        exact: true,
      },
    ],
  },
];

export default routes;
